import { render, staticRenderFns } from "./TenderListInfo.vue?vue&type=template&id=8d0ff194&scoped=true&"
import script from "./TenderListInfo.vue?vue&type=script&lang=js&"
export * from "./TenderListInfo.vue?vue&type=script&lang=js&"
import style0 from "./TenderListInfo.vue?vue&type=style&index=0&id=8d0ff194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0ff194",
  null
  
)

export default component.exports